import type { RangeKey } from "@features/dashboard/model/types";

export const RANGE_SECONDS: Record<RangeKey, number | null> = {
  "7d": 7 * 86400,
  "30d": 30 * 86400,
  "90d": 90 * 86400,
  "1y": 365 * 86400,
  all: null,
};

export const RANGE_LABEL: Record<RangeKey, string> = {
  "7d": "last 7d",
  "30d": "last 30d",
  "90d": "last 90d",
  "1y": "last year",
  all: "all time",
};

export function rangeToFrom(range: RangeKey, nowSeconds = Math.floor(Date.now() / 1000)): number | undefined {
  const seconds = RANGE_SECONDS[range];
  return seconds === null ? undefined : nowSeconds - seconds;
}

export function shouldUseDailyBucket(range: RangeKey): boolean {
  return range === "1y" || range === "all";
}
